<template>
  <StandardDialog
    border_radius="10px"
    @click-outside="$router.push({name: 'ProjectTaktPlan'})"
    >
    <template #content>
      <CloudPrint>
        <template #header>
          <div>CLOUD.prints - {{project_name}}</div>
          <v-btn
            icon
            @click="$router.push({name: 'ProjectTaktPlan'})"
            style="position: absolute; right: 10px"
            >
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </template>
        <template #list>
          <div
            v-if="cloudprints.length === 0 && cloudprints_loading"
            style="display: flex; justify-content: center; padding: 10px"
            >
            <v-progress-circular
            indeterminate
            color="primary"
            ></v-progress-circular>
          </div>
          <div
            v-if="cloudprints.length === 0 && !cloudprints_loading"
            style="display: flex; justify-content: center; padding: 10px"
            >
            no cloudprints created
          </div>
          <template v-else>
          <CloudPrintListEntry
            v-for="cloudprint in cloudprints"
            :key="cloudprint.id"
            :style="$route.name.includes('Details') && $route.params.cloudprint_id === cloudprint.id?'background-color: grey':''"
            @click.native="$router.push({name: 'TaktPlanCloudPrintDetails', params: {cloudprint_id: cloudprint.id}})"
            >
            {{cloudprint.name}}
          </CloudPrintListEntry>
          </template>
          <CloudPrintListEntry
            v-if="hasProjectPermission({
              project_id: $route.params.project_id,
              ppermission: 'Add Trains'
            })"
            style="position: sticky; bottom: 0px; justify-content: center; background-color: #4CAF50; border: none"
            @click.native="$router.push({name: 'TaktPlanCloudPrintCreate'})"
            >
            <v-icon>add</v-icon>
            Create CLOUD.print
          </CloudPrintListEntry>
        </template>
        <template #details>
          <router-view/>
        </template>
      </CloudPrint>
    </template>
  </StandardDialog>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue'
  import CloudPrint from '@/components/CloudPrint/CloudPrint.component.vue'
  import CloudPrintListEntry from '@/components/CloudPrint/CloudPrintListEntry.component.vue'
  export default {
    props: ['cloudprints', 'project_name', 'project_id'],
    components: {
      StandardDialog,
      CloudPrint,
      CloudPrintListEntry
    },
    data: () => ({
      cloudprints_loading: false,
    }),
    created() {
      this.cloudprints_loading = true;
      this.requestUObject({
        url: [
          {projects: this.project_id},
          {cloudprints: ''},
          {'showWithEntitiesNormalized': ''}
        ],
        add_u_object: true,
      }).then(() => {
        this.cloudprints_loading = false;
      });
      this.requestUObject({
        url: [
          {projects: this.project_id},
          {histprojects: ''},
          {'showWithEntitiesNormalized': ''}
        ],
        add_u_object: true,
      })
    },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjectsFiltered',
      ]),
      ...mapGetters('Project', [
        'hasProjectPermission',
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'requestUObject',
      ]),
    }
  }
</script>
<style>
  .class {

  }
</style>
